var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#00695C",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M220-820H740V-160H220Z M290-760h80v80h-80Z M440-760h80v80h-80Z M590-760h80v80h-80Z M290-640h80v80h-80Z M440-640h80v80h-80Z M590-640h80v80h-80Z M290-520h80v80h-80Z M440-520h80v80h-80Z M590-520h80v80h-80Z M440-320h80v160h-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDepartmentIcon);
export default __webpack_public_path__ + "static/media/marker-department-icon.e47a7a267f0d0942e4ce7c7111aaaaa2.svg";
export { ForwardRef as ReactComponent };